import { render } from "./SavePage.vue?vue&type=template&id=5c36bc07"
import script from "./SavePage.vue?vue&type=script&lang=js"
export * from "./SavePage.vue?vue&type=script&lang=js"
script.render = render

export default script